'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ProgressButtonComponent } from './component';
import { LKIcon } from '../icon/module';

@NgModule({
  imports     : [
    BrowserModule,
    LKIcon
  ],
  declarations: [ProgressButtonComponent],
  exports     : [ProgressButtonComponent]
})
export class LKProgressButton {
}
